import React from "react";
import Dropzone from "react-dropzone";
import {
  Checkbox,
  RaisedButton,
  CircularProgress,
  TextField
} from "material-ui";
import { Table } from "reactable";

import connectToStores from "alt-utils/lib/connectToStores";
import BulkImportActions from "../actions/BulkImportActions";
import BulkImportStore from "../stores/BulkImportStore";

import InfoNotice from "./partials/info-notice.jsx";

import CheckCircleIcon from "material-ui/svg-icons/action/check-circle";
import ErrorIcon from "material-ui/svg-icons/alert/error";

import config from "../config";
import InjectedSelect from "./partials/injected-select.jsx";
import Label from "./partials/label.jsx";
import QuillEditor from "./partials/quill-editor.jsx";
import LinkLike from "./partials/link-like.jsx";

class BulkImportPeople extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedEventBucket: null,
      subjectLine: "",
      introMessage: "",
      extraMessage: "",
      skipExisting: false,
      csvFile: null,
      userReadyToImport: false
    };

    this.reset = this.reset.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.import = this.import.bind(this);
  }

  static getStores() {
    return [BulkImportStore];
  }

  static getPropsFromStores() {
    return BulkImportStore.getState();
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getStyles() {
    return {
      progressContainer: {
        margin: "0 auto",
        textAlign: "center",
        padding: 10
      },
      restartLink: {
        textDecoration: "underline",
        cursor: "pointer",
        paddingLeft: 2
      },
      icon: {
        width: 80,
        height: "auto",
        color: "rgb(2, 136, 209)"
      },
      message: {
        marginTop: 10
      },
      dropzone: {
        padding: 20,
        lineHeight: "1.25",
        padding: 10,
        border: "1px dashed #ccc",
        cursor: "pointer"
      },
      actions: {
        marginTop: 10
      },
      previewExtraMessage: {
        padding: 20,
        border: "1px dashed #ccc"
      }
    };
  }

  componentWillMount() {
    this.reset();
  }

  reset() {
    this.setState({
      userReadyToImport: false
    });
    BulkImportActions.reset.defer();
  }

  onDrop(files) {
    if (!files.length) {
      return;
    }
    this.setState({
      csvFile: files[0]
    });
  }

  import() {
    BulkImportActions.importPeople({
      eventBucket: this.state.selectedEventBucket.id,
      subjectLine: this.state.subjectLine,
      introMessage: this.state.introMessage,
      extraMessage: this.state.extraMessage,
      skipExisting: this.state.skipExisting,
      csvFile: this.state.csvFile,
      preview: !this.state.userReadyToImport
    });
    window.scrollTo(0, 0);
  }

  _makeCsvLink() {
    return config.endpoint + "bulk_import/example/people";
  }

  _makeTable(people) {
    return (
      <Table
        className={"bordered striped responsive-table"}
        columns={[
          { key: "name", label: "Name" },
          { key: "email", label: "Email" },
          { key: "phone_number", label: "Phone number" },
          { key: "mailing_address", label: "Mailing address" },
          { key: "images", label: "Supplementary data images" },
          { key: "notes", label: "Notes" },
          { key: "errors", label: "Errors" }
        ]}
        data={people.map(p => {
          return {
            name: p.person.name,
            email: p.person.email,
            phone_number: p.person.phone_number,
            mailing_address: p.person.mailing_address,
            images: (
              <div>
                {p.person.supplementary_data_images.map(url => (
                  <a href={url} target="_blank">
                    <img src={url} style={{ height: 20 }} />
                  </a>
                ))}
              </div>
            ),
            notes: (
              <div
                dangerouslySetInnerHTML={{ __html: p.person._note }}
                className="tenant-injected-html"
              />
            ),
            errors: p.errors.join(", ")
          };
        })}
      />
    );
  }

  render() {
    let {
        isImporting,
        importCompleted,
        importSuccessful,
        importMessage,
        importOrder,
        previewData
      } = this.props,
      styles = this.getStyles();

    if (isImporting || (importCompleted && !previewData)) {
      return (
        <div style={styles.progressContainer}>
          {isImporting ? (
            <CircularProgress size={1.5} mode="indeterminate" />
          ) : importSuccessful ? (
            <CheckCircleIcon style={styles.icon} />
          ) : (
            <ErrorIcon style={styles.icon} />
          )}
          <div style={styles.message}>
            {isImporting ? (
              <div>
                {this.state.userReadyToImport ? "Importing" : "Previewing"}{" "}
                people...
                <br />
                This may take a little while.
              </div>
            ) : (
              importMessage
            )}
            {!isImporting ? (
              <a style={styles.restartLink} onTouchTap={this.reset}>
                (restart)
              </a>
            ) : null}
          </div>
        </div>
      );
    }

    if (previewData && this.state.selectedEventBucket) {
      return (
        <div>
          <p>
            We detected {previewData.people.length} people in your uploaded
            data. Have a look:
          </p>
          {this._makeTable(previewData.people)}
          <p>
            Each individual in the above list will receive an email with the
            subject "<b>{previewData.subject}</b>" that in addition to
            instructions about logging in also contains the following content:
          </p>
          <div
            className="tenant-injected-html"
            style={styles.previewExtraMessage}
            dangerouslySetInnerHTML={{
              __html:
                previewData.body ||
                "<i>[No additional message will be attached]</i>"
            }}
          />
          <p>
            If everything looks all right, confirm & start the import.
            Otherwise,{" "}
            <LinkLike onTouchTap={this.reset}>edit settings</LinkLike>.
          </p>
          <div>
            <Checkbox
              label={`Yes, I'm ready to import ${previewData.people.length} people & send associated emails.`}
              checked={this.state.userReadyToImport}
              onCheck={() =>
                this.setState({
                  userReadyToImport: !this.state.userReadyToImport
                })
              }
            />
          </div>
          <div style={styles.actions}>
            <RaisedButton
              label="Start import"
              primary={true}
              disabled={!this.state.userReadyToImport}
              onTouchTap={this.import}
            />
          </div>
        </div>
      );
    }

    return (
      <div>
        <h1>Bulk import people</h1>
        <InfoNotice style={{ marginTop: 20 }}>
          Check out our{" "}
          <a
            href="https://help.eventive.org/people/bulk-import-people"
            target="_blank"
          >
            guide to importing people
          </a>
          .
        </InfoNotice>
        <p>
          Use this wizard to import people in bulk. Just download the Excel
          template, fill in your data, and upload. Every user will receive an
          email notifying them about their new account&mdash;you can use the
          "additional note" field to explain why they're receiving it.
        </p>
        <p>
          <i>
            Note: If you're trying to import passholders (e.g. everyone being
            imported receives a free pass), use our{" "}
            <a
              href="https://help.eventive.org/passes/bulk-import-passes"
              target="_blank"
            >
              bulk pass import
            </a>{" "}
            tool instead.
          </i>
        </p>
        <div>
          <InjectedSelect
            value={
              this.state.selectedEventBucket &&
              this.state.selectedEventBucket.id
            }
            types={["event_buckets"]}
            label="Event bucket to use in link to activate account"
            labelFormatter={b => b.name}
            changeValueFunction={o => o}
            onChange={selected =>
              this.setState({ selectedEventBucket: selected })
            }
          />
        </div>
        <div>
          <Label>
            Add spreadsheet (
            <a target="_blank" href={this._makeCsvLink()}>
              download template
            </a>
            )
          </Label>
          <Dropzone
            style={styles.dropzone}
            multiple={false}
            onDrop={this.onDrop}
          >
            {({ isDragActive, isDragReject, acceptedFiles, rejectedFiles }) => {
              return isDragActive ? (
                "Release to select."
              ) : acceptedFiles.length ? (
                <span>
                  One spreadsheet <i>({acceptedFiles[0].name})</i> ready to
                  import.
                </span>
              ) : (
                "Drop spreadsheet here, or click to select."
              );
            }}
          </Dropzone>
        </div>
        <div>
          <TextField
            value={this.state.subjectLine}
            floatingLabelText="Subject line"
            floatingLabelFixed={true}
            fullWidth={true}
            onChange={e => this.setState({ subjectLine: e.target.value })}
          />
        </div>
        <div>
          <Label>Email notification introduction</Label>
          <QuillEditor
            value={this.state.introMessage}
            onChange={v => this.setState({ introMessage: v })}
            basic={true}
          />
        </div>
        <p>
          <i>
            ["Click here to activate your account" link will be inserted between
            introduction & additional content]
          </i>
        </p>
        <div>
          <Label>Additional email content</Label>
          <QuillEditor
            value={this.state.extraMessage}
            onChange={v => this.setState({ extraMessage: v })}
            basic={true}
          />
        </div>
        <div style={{ margin: "2em 0" }}>
          <Checkbox
            label={`Do not email existing customers`}
            checked={this.state.skipExisting}
            onCheck={() =>
              this.setState({ skipExisting: !this.state.skipExisting })
            }
          />
        </div>

        <div style={styles.actions}>
          <RaisedButton
            label="Preview import..."
            primary={true}
            disabled={!(this.state.selectedEventBucket && this.state.csvFile)}
            onTouchTap={this.import}
          />
        </div>
      </div>
    );
  }
}

export default connectToStores(BulkImportPeople);



// WEBPACK FOOTER //
// ./src/app/components/bulk-import-people.jsx